import type { ComponentProps } from "react";

export default function CheckIcon(props: ComponentProps<"svg">) {
  return (
   <svg 
   width="15" 
   height="11" 
   viewBox="0 0 15 11" 
   fill="none" 
   xmlns="http://www.w3.org/2000/svg"
   {...props}
   >
        <path d="M5.114 11C4.98446 11 4.86301 10.9793 4.74965 10.938C4.6363 10.8973 4.53104 10.8277 4.43388 10.7293L0.256017 6.49664C0.0778914 6.31618 -0.00728528 6.08224 0.000487491 5.79481C0.008908 5.50804 0.102181 5.27442 0.280307 5.09396C0.458433 4.9135 0.685139 4.82327 0.960425 4.82327C1.23571 4.82327 1.46242 4.9135 1.64054 5.09396L5.114 8.61297L13.3483 0.270694C13.5264 0.0902313 13.7573 0 14.041 0C14.3241 0 14.5547 0.0902313 14.7328 0.270694C14.9109 0.451156 15 0.684772 15 0.971544C15 1.25897 14.9109 1.49292 14.7328 1.67338L5.79412 10.7293C5.69696 10.8277 5.5917 10.8973 5.47835 10.938C5.365 10.9793 5.24355 11 5.114 11Z" fill="currentColor"/>
    </svg>
  );
}